import CashbackPopupFrame from './CheckoutExampleFrame';

export default CashbackPopupFrame;
